module.exports = __webpack_public_path__ + "static/media/krx-trading-investor-00.632c2475.jpg";